var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import "./FileUploadingCard.css";
import classNames from "classnames";
import FileUploadingCardFile from "./components/FileUploadingCardFile";
import FileUploadingCardBadge from "./components/FileUploadingCardBadge";
import FileUploadingCardAction from "./components/FileUploadingCardAction";
import { LoaderMj } from "../../specifique";
import { Typography } from "../../technical-fundamental";
var FileUploadingCard = forwardRef(function (_a, ref) {
    var isLoading = _a.isLoading, className = _a.className, style = _a.style, children = _a.children, otherProps = __rest(_a, ["isLoading", "className", "style", "children"]);
    var fileUploadingCardFile = null;
    var fileUploadingCardAction = null;
    var fileUploadingCardBadge = null;
    var recupererElement = function (child) {
        switch (child.type) {
            case FileUploadingCardFile:
                fileUploadingCardFile = child;
                break;
            case FileUploadingCardBadge:
                fileUploadingCardBadge = child;
                break;
            case FileUploadingCardAction:
                fileUploadingCardAction = child;
                break;
        }
    };
    if (Array.isArray(children)) {
        children.forEach(function (child) {
            recupererElement(child);
        });
    }
    else if (React.isValidElement(children)) {
        recupererElement(children);
    }
    return (React.createElement("div", __assign({}, otherProps, { className: classNames(className !== null && className !== void 0 ? className : "", "ssg-file-upload-card"), style: style, ref: ref }),
        fileUploadingCardFile,
        isLoading ? (React.createElement("div", { className: "ssg-file-upload-card__loader" },
            React.createElement(Typography, { variant: "text", size: "xs", noMarginBottom: true }, "Chargement en cours ..."),
            React.createElement(LoaderMj, { color: "#000091", noId: true }))) : (React.createElement("div", { className: "ssg-file-upload-card__actionZone" },
            fileUploadingCardBadge,
            fileUploadingCardAction))));
});
export default FileUploadingCard;
